import { useState } from 'react';
import { updateMenuPermission } from '../../helpers/api_helper';

const useUpdateMenuPermission = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const updateMenuPermissionHook = async (menu_id, role, data) => {
        setLoading(true);
        setError(null);
        try {
            const response = await updateMenuPermission(menu_id, role, data);
            return response;
        } catch (err) {
            const errorMessage = `Failed to update menu permission: ${err.message || 'Unknown error'}`;
            setError(errorMessage);
            throw new Error(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    return { updateMenuPermission: updateMenuPermissionHook, loading, error };
};

export default useUpdateMenuPermission;